var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bot-file-message assetMessage sc-message--text",
      style: Object.assign(
        {},
        _vm.messageColors || {},
        _vm.extendedStyle || {}
      ),
    },
    [
      _c("div", { staticClass: "media-content-wrapper" }, [
        _c(
          "a",
          { attrs: { href: _vm.fileSrc(), download: "", target: "_blank" } },
          [
            _vm.getFile(_vm.fileSrc())
              ? _c(
                  "div",
                  {
                    staticClass: "fi",
                    class: "fi-" + _vm.getFile(_vm.fileSrc()),
                  },
                  [
                    _c("div", { staticClass: "fi-content" }, [
                      _vm._v(_vm._s(_vm.getFile(_vm.fileSrc()))),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "media-content-text",
                class: _vm.data.author === "me" ? "received" : "sent",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.download")) +
                    "\n            "
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.data.data.meta
        ? _c(
            "span",
            {
              staticClass: "sc-message--meta",
              class: _vm.data.author === "me" ? "received" : "sent",
            },
            [_vm._v(_vm._s(_vm.data.data.meta))]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }